
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'DocumentIconSmall',

  props: {
    mimeTypeSlag: String
  }
})
